import { TableHeaderCategoryConfig } from "../../../../components/tables/tableContext/TableContext";
import { PickingBoxHistoryItemInterface } from "../../../../redux/interfaces/inventory.interface";
import { dateToString } from "../../../../utils/dateAndTime";

export const pickingBoxHistoryTableHeader: TableHeaderCategoryConfig[] = [
  { value: "stock_vechi", label: "Stoc vechi", minW: 125 },
  { value: "stock_nou", label: "Stoc nou", minW: 125 },
  { value: "Op", label: "Nr. comanda", minW: 125 },
  { value: "nume", label: "Operator", minW: 125 },
  { value: "ts_operatie", label: "Data modificare", minW: 175 },
];

export const getPickingBoxHistoryTableData = (
  items: PickingBoxHistoryItemInterface[],
) =>
  items.map((item) => ({
    id: item.idCutie_arh,
    crudData: item,
    data: [
      { title: item.stock_vechi },
      { title: item.stock_nou },
      { title: item.Op ?? "-" },
      { title: item.nume ? `${item.nume} ${item.prenume}` : "-" },
      { title: item.ts_operatie ? dateToString(item.ts_operatie) : "-" },
    ],
  }));
